import React, { useEffect, useState } from 'react';
import { useAnalytics } from '../../analytics/hooks/use-analytics.ts';

const useShowFullView = () => {
    const localStorageKey = 'customer_view_toggled';

    const [customerViewToggled, setIsFullViewToggled] = useState(false);
    const sendAnalyticsEvent = useAnalytics();

    useEffect(() => {
        const storedValue = localStorage.getItem(localStorageKey);
        setIsFullViewToggled(storedValue ? storedValue === 'true' : false);
    }, []);

    const toggleFullView = (enabled = !customerViewToggled) => {
        localStorage.setItem(localStorageKey, JSON.stringify(enabled));
        setIsFullViewToggled(enabled);
        sendAnalyticsEvent('customer_view_toggled', { enabled });
    };

    return { customerViewToggled, toggleFullView };
};

type CustomerModeContextValue = {
    customerViewToggled: boolean;
    toggleFullView: (enabled?: boolean) => void;
};

export const CustomerModeContext = React.createContext<CustomerModeContextValue>({
    customerViewToggled: false,
    toggleFullView: () => undefined,
});

type Props = {
    children: React.ReactNode | React.ReactNode[];
};

export const CustomerModeProvider: React.FC<Props> = ({ children }) => {
    const fullView = useShowFullView();

    return <CustomerModeContext.Provider value={fullView}>{children}</CustomerModeContext.Provider>;
};

export const useCustomerMode = () => {
    return React.useContext(CustomerModeContext);
};

export const useCustomerModeActive = () => {
    const { customerViewToggled } = React.useContext(CustomerModeContext);
    return customerViewToggled;
};
